import * as React from "react";
import "./Header.scss";
import NavMenu from "components/NavMenu/NavMenu";
import Menu from "components/Menu/Menu";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import LocaleDropdown from "components/LocaleDropdown/LocaleDropdown";

interface HeaderProps {
  isCabinet?: boolean;
  logout?: () => void;
  isSetup?: boolean;
}

const Header = ({ isCabinet=false, logout, isSetup=false}: HeaderProps) => {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="header-container" id="home">
      <NavMenu isCabinet={isCabinet} logout={logout} isSetup={isSetup} />
      {(!isCabinet && !isSetup) &&<LocaleDropdown />}
      {(!isCabinet && !isSetup) && (
        <>
          {open ? (
            <div
              className="humburger-icon"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseOutlinedIcon className="menu-icon" />
            </div>
          ) : (
            <div
              className="humburger-icon"
              onClick={() => {
                setOpen(true);
              }}
            >
              <MenuIcon className="menu-icon" />
            </div>
          )}
          {open && <Menu setOpen={setOpen} />}
        </>
      )}
    </div>
  );
};

export default Header;
